export const PUSH_SNACKBAR = "PUSH_SNACKBAR"
export const POP_SNACKBAR = "POP_SNACKBAR"

export const STORE_ENTRY = "STORE_ENTRY"
export const STORE_ENTRIES = "STORE_ENTRIES"
export const STORE_PREVIEW_ENTRY = "STORE_PREVIEW_ENTRY"
export const STORE_PREVIEW_ENTRIES = "STORE_PREVIEW_ENTRIES"
